import axios from "axios";
import { ENV_REACT_APP } from "../Configurations/ENV_Config";
import { getToken } from "../Utils/tokenStorage";

// Header bell (October 2026). Backed by /api/me/notifications.
const apiBase = (path: string) =>
  `${ENV_REACT_APP?.REACT_APP_API_BASE_URL || ""}${path}`;

const authHeaders = (): Record<string, string> => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export type NotificationType =
  | "claim_submitted"
  | "claim_approved"
  | "claim_rejected"
  | "ownership_transferred"
  | "ownership_removed"
  | "vendor_record"
  | "bid_received"
  | "service_request_update"
  | "job_completed"
  | "maintenance_due"
  | "maintenance_overdue";

export interface AppNotification {
  _id: string;
  type: NotificationType;
  title: string;
  body: string;
  link: string | null;
  readAt: string | null;
  createdAt: string;
}

export const getNotifications = async (): Promise<{ notifications: AppNotification[]; unreadCount: number }> => {
  const res = await axios.get(apiBase("/api/me/notifications"), { headers: authHeaders() });
  const d = res.data?.data || {};
  return { notifications: d.notifications || [], unreadCount: d.unreadCount || 0 };
};

export const markNotificationRead = async (id: string): Promise<void> => {
  await axios.post(apiBase(`/api/me/notifications/${id}/read`), {}, { headers: authHeaders() });
};

export const markAllNotificationsRead = async (): Promise<void> => {
  await axios.post(apiBase("/api/me/notifications/read-all"), {}, { headers: authHeaders() });
};

// Email switches (October 2026): the daily maintenance-reminder email.
export interface EmailPreferences {
  maintenanceReminderEmails: boolean;
}

export const getEmailPreferences = async (): Promise<EmailPreferences> => {
  const res = await axios.get(apiBase("/api/me/email-preferences"), { headers: authHeaders() });
  return { maintenanceReminderEmails: res.data?.data?.maintenanceReminderEmails !== false };
};

export const setEmailPreferences = async (prefs: EmailPreferences): Promise<EmailPreferences> => {
  const res = await axios.patch(apiBase("/api/me/email-preferences"), prefs, { headers: authHeaders() });
  return { maintenanceReminderEmails: res.data?.data?.maintenanceReminderEmails !== false };
};
